import React, { useState, useEffect } from 'react'
import AnnouncementsBox from '../AnnouncementsBox'
import Button, { ButtonType } from '../../Button'
import { AnnouncementsCharacterCounterProps } from './../types'
import componentStyle from './AnnouncementsCharacterCounter.module.scss'
import styles from '@bt-react/styles'

const AnnouncementsCharacterCounter: React.FC<AnnouncementsCharacterCounterProps> = ({ handleSubmit, disable }) => {

  const [ characterLength, setCharacterLength ] = useState(1000)
  const [ announcement, setAnnouncement ] = useState('')

  useEffect(() => {

    setCharacterLength(() => 1000 - announcement.length)

  }, [announcement])

  const handleChange = e => setAnnouncement(e.target.value)

  return <div className={ componentStyle['announcements-announcementscharactercounter-container']} data-bdd="announcements-announcementscharactercounter-container">
    <div className={ componentStyle['announcementscharactercounter-sec']}>
      <AnnouncementsBox disable={disable} handleChange={handleChange}/>
    </div>
    <div className={`${componentStyle['character-footer']} ${styles['row']}`}>
      <div className={`${componentStyle['character-counter']} ${styles['col-5']}`}>
        <div className={ componentStyle['character'] }>{characterLength.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} characters</div>
      </div>
      <div className={`${componentStyle['character-button']} ${styles['col-7']}`}>
        <Button
          type={ ButtonType.buttonType.button }
          onClick={() => handleSubmit(announcement)}
          text="Display announcement"
          data-bdd="announcement-character-counter"
          className={ componentStyle['button'] }
          disabled={disable || (!disable && characterLength === 1000)}
        />
      </div>
    </div>
  </div>

}

export default AnnouncementsCharacterCounter
